// 设备新增 & 编辑
export default {
    heard_title: "设备新增",
    radio_detail: "设备详情",
    radio_record: "维修记录",
    fl_type: "设备种类",
    fp_type: "请选择设备种类",
    op_kart: "卡丁车",
    op_other: "其他",
    fl_cart: "卡丁车:",
    radio_kid: "儿童车",
    radio_adult: "成人车",
    fl_kart: "车型名称:",
    fp_kart: "请选择车型",
    fl_name: "设备名称:",
    fp_name: "请输入设备名称",
    fl_number: "编号:",
    fp_number: "请输入编号",
    fl_ID: "ID:",
    fp_ID: "请输入ID",
    fl_brand: "品牌：",
    fp_brand: "请输入品牌",
    fl_itemSpec: "参数/规格:",
    fp_itemSpec: "请输入参数/规格",
    fl_buyTime: "购入日期",
    fp_buyTime: "请选择日期",
    fl_buyPrice: "购入价格:",
    fp_buyPrice: "请输入购入价格",
    buyPrice_unit: "元",
    fl_scrapTime: "报废日期:",
    fp_scrapTime: "请选择日期:",
    fl_scrapPrice: "报废价格:",
    fp_scrapPrice: "请输入报废价格",
    scrapPrice_unit: "元",
    fl_status: "状态",
    fp_status: "请选择状态",
    op_inUse: "使用中",
    op_ontUsed: "未使用",
    op_repair: "维修中",
    op_scrapped: "已报废",
    btn_submit: "提交",
    fl_fixDate: "维修日期：",
    fp_fixDate: "选择日期",
    fl_content: "维修内容",
    fp_content: "最多可输入50字",
    btn_fixSubmit: "提交",

    // 维修记录
    fix_title: "维修记录",
    fix_date: ".维修日期:",
    fix_content: "维修内容:",

    // 提示
    em_type: "请选择设备种类",
    em_buyChannel: "请选择购买途径",
    em_name: "请输入设备名称",
    em_code: "请输入设备ID",
    em_codeMax: "设备ID最大长度为10",
    em_number: "请输入设备编号",
    em_numberMax: "设备编号最大长度为6",
    em_brand: "请输入品牌",
    em_buyTime: "请选择购入日期",
    em_status: "请选择状态",
    em_itemNo: "请输入货号",
    em_itemNoMax: "货号最大长度为15",
    em_date: "请选择维修日期",
    em_content: "请输入维修内容",

    sm_addFixRecord: "添加维修记录成功",
    em_addFixRecord: "添加维修记录失败",
    em_kartCategory: "请先选择类型再选取设备名称",
    sm_crate: "保存成功"
};
